import { FC } from 'react';
import ProTimeline, { TimelineProps } from './timeline';
import ProTimelineItem, { TimelineItemProps } from './item';

export type ITimelineComponent = FC<TimelineProps> & {
  Item: FC<TimelineItemProps>;
};

const TransTimeline = ProTimeline as ITimelineComponent;
TransTimeline.Item = ProTimelineItem;

export default TransTimeline;
